import * as React from "react";
import { UitkSecondaryButton } from "uitk-react-button";
import { useLocalization } from "@shared-ui/localization-context";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

interface SeeAllButtonProps {
  locationName: string;
  context: ExtendedContextStore;
  seeAllUrl: string;
  originCityName: string;
  originName: string;
}

interface ButtonTrackedProps {
  moduleName: string;
  rfrr: string;
  text: string;
  href: string | undefined;
  className: string | "";
}

const ButtonTracked = FlexClickTracker(UitkSecondaryButton);
const moduleName = "packages";
const rfrr = "ViewAllTrips";

export const SeeAllButton: React.FC<SeeAllButtonProps> = (props: SeeAllButtonProps) => {
  const { locationName, seeAllUrl, originName } = props;
  const { formatText } = useLocalization();
  const weGotMoreMessage = formatText("package.seeAllAvailableProperties", originName, locationName);
  const displayMessage = weGotMoreMessage && originName !== "";
  const btnTrackedProps: ButtonTrackedProps = {
    moduleName,
    rfrr,
    text: formatText("package.viewAllTrips"),
    href: seeAllUrl,
    className: "btn-view-all-trips all-y-margin-two",
  };

  return (
    <div className="uitk-type-center all-b-padding-one">
      <div className="uitk-type-bold all-r-margin-one uitk-type-300 all-t-padding-two">
        {formatText("hotels.lookingFor")}
      </div>
      {displayMessage && <div className="uitk-type-300">{weGotMoreMessage}</div>}
      <div className="uitk-cell">
        <ButtonTracked {...btnTrackedProps} />
      </div>
    </div>
  );
};
